import { useMutation, useQuery } from "@tanstack/react-query";
import useAxiosInstance from "./axiosInstance.utils";
import { errorFormat } from "./handleError.utils";
import { onSuccessMessage, queryClient } from "./reactQuery.utils";

/**
 * :::::::MUTATIONS:::::::::::
 */

export function useCreateUnionMutation(keyData) {
  const { postApi } = useAxiosInstance();
  async function createUnionApi(data) {
    try {
      const api = `/union`;
      const apiResponse = await postApi(api, data);
      return apiResponse;
    } catch (error) {
      return errorFormat(error);
    }
  }

  const { isPending: loading, mutateAsync } = useMutation({
    mutationKey: ["createUnionApi", ...keyData],
    mutationFn: (data) => createUnionApi(data),
    onSuccess: (data) => {
      queryClient.invalidateQueries("unions");
      onSuccessMessage(data, 201);
    },
    onError: (err) => {
      return errorFormat(err);
    }
  });

  return { loading, createUnion: mutateAsync };
}

export function useUpdateUnionMutation(keyData) {
  const { putApi } = useAxiosInstance();
  async function updateUnionApi(data) {
    try {
      const api = `/union`;
      const apiResponse = await putApi(api, data);
      return apiResponse;
    } catch (error) {
      return errorFormat(error);
    }
  }
  const { isPending: loading, mutateAsync } = useMutation({
    mutationKey: ["updateUnionApi", ...keyData],
    mutationFn: (data) => updateUnionApi(data),
    onSuccess: (data) => {
      queryClient.invalidateQueries("unions");
      onSuccessMessage(data, 200);
    },
    onError: (err) => {
      return errorFormat(err);
    }
  });

  return { loading, updateUnion: mutateAsync };
}

export function useDeleteUnionMutation(keyData) {
  const { deleteApi } = useAxiosInstance();
  async function deleteUnionApi(id) {
    try {
      const api = `/union/${id}`;
      const apiResponse = await deleteApi(api);
      return apiResponse;
    } catch (error) {
      return errorFormat(error);
    }
  }

  const { isPending: loading, mutateAsync } = useMutation({
    mutationKey: ["deleteUnionApi", ...keyData],
    mutationFn: (data) => deleteUnionApi(data),
    onSuccess: (data) => {
      queryClient.invalidateQueries("unions");
      onSuccessMessage(data, 200);
    },
    onError: (err) => {
      return errorFormat(err);
    }
  });

  return { loading, deleteUnion: mutateAsync };
}

/**
 * :::::::QUERIES:::::::::::
 */
export function useGetAllUnionQuery({ query, options = {}, key = "" }) {
  const { getApi } = useAxiosInstance();
  async function getAllUnionApi(query) {
    try {
      const api = `/unions${query ?? ""}`;
      const apiResponse = await getApi(api);
      return apiResponse;
    } catch (error) {
      return errorFormat(error);
    }
  }

  const {
    data,
    isPending: loading,
    ...rest
  } = useQuery({
    queryKey: [`getAllUnion-${query ?? ""}${key ? "-" + key : ""}`],
    queryFn: () => getAllUnionApi(query),
    ...options
  });
  const newData = data?.data?.data ?? {};
  const parents = data?.data?.parents ?? [];
  return { data: newData, parents, loading, ...rest };
}
